import React from 'react';

/** Контекст решения остаётся заметным и при длинном названии позиции. */
export const DialogContext: React.FC<{ supplier: string; subject: string }> = ({ supplier, subject }) => (
    <div className="ws2-dialog__context">
        <strong>{supplier}</strong>
        <span>{subject}</span>
    </div>
);
